import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiService } from 'src/app/services/api.service';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Employees } from '../../../interfaces/employees';
import { Users } from 'src/app/models/interfaces/users';
import { Helps } from 'src/app/libs/helps';
import { SmsUtils } from 'src/app/modules/common/sms/sms-utils';

@Component({
  selector: 'app-edit-users',
  templateUrl: './edit-users.component.html',
  styleUrls: ['./edit-users.component.css']
})
export class EditUsersComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private apiFull: ApiService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private modal: NgbModal,
    private helps: Helps
  ) { }
  ngOnInit(): void {
    this.level = this.helps?.getToken()?.level;
    this.getState();
    if (this.users != null) {
      this.get(this.users);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['users'].currentValue != this.users) {
      this.get(this.users);
    }
  }
  notSendVisSms = true;
  notSendVisEmail = true;
  notSendProvSms = true;
  notSendProvEmail = true;
  level: number = 0;
  @Output()
  success = new EventEmitter<boolean>();
  @Input()
  users: Users;
  items: any;
  form1: FormGroup = this.formBuilder.group({
    id: [],
    name: ['', Validators.required],
    lastname: [''],
    rut: ['', [Validators.required, MyValidators.rut]],
    email: [''],
    phone: [''],
    pass: [''],
    state_id: [0],
    stores_id: [0],
    send_not_vis_sms: [0],
    send_not_vis_email: [0],
    send_not_prov_sms: [0],
    send_not_prov_email: [0]
  });
  isValidPhone: boolean = false;
  isValidEmail: boolean = false;
  get(item: Users) {
    this.api.getUser(item?.id).subscribe((res) => {
      let data = res.data as Users;
      this.form1.patchValue(res.data);
      this.form1.get('rutview')?.setValue(data?.rut);
      this.checkEmail();
      this.checkPhoneNumber();
      if (this.level < 99) {
        this.form1.disable();
      }
    }, error => {
      this.toast.warning(error.error.mistakes, error.error.msg, { enableHtml: true, closeButton: true });
      this.modal.dismissAll();
    });
  }
  getState() {
    this.apiFull.getState().subscribe((res) => {
      this.items = res.data;
    });
  }

  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1
        .get('rut')
        ?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }
  update() {
    if (this.level < 99) {
      this.toast.warning("Usted no tiene los privilegios para efectujar esta modificación");
      return;
    }
    if ((this.form1.get('phone')?.value.length > 1) && (!SmsUtils.isNumberPhone(this.form1.get('phone')?.value))) {
      this.toast.warning("El numero de telefono ingresado no es valido 8 caracteres.");
      return;
    }
    this.api.updateUsers(this.form1).subscribe(
      (response) => {
        this.toast.success(response.msg, 'Administrador');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (err) => {
        this.toast.warning(err.error.mistakes, err.error.msg, { enableHtml: true, closeButton: true });
      }
    );
  }
  activeSendVisSms(event: any) {
    let checked: boolean = event?.target.checked;
    let value = (checked) ? 1 : 0;
    this.form1.get('send_not_vis_sms')?.setValue(value);
  }
  activeSendProvSms(event: any) {
    let checked: boolean = event?.target.checked;
    let value = (checked) ? 1 : 0;
    this.form1.get('send_not_prov_sms')?.setValue(value);
  }
  activeSendVisEmail(event: any) {
    let checked: boolean = event?.target.checked;
    let value = (checked) ? 1 : 0;
    this.form1.get('send_not_vis_email')?.setValue(value);
  }
  activeSendProvEmail(event: any) {
    let checked: boolean = event?.target.checked;
    let value = (checked) ? 1 : 0;
    this.form1.get('send_not_prov_email')?.setValue(value);
  }
  checkPhoneNumber(type:number=1) {
    if (SmsUtils.isNumberPhone(this.form1.get('phone')?.value)) {
      console.log("Valido:", this.form1.get('phone')?.value);
        this.notSendVisSms = false;
        this.notSendProvSms = false;

    } else {
      console.log("No valido:", this.form1.get('phone')?.value);
        this.notSendVisSms = true;
        this.form1.get('send_not_vis_sms')?.setValue(0);
        this.notSendProvSms = true;
        this.form1.get('send_not_prov_sms')?.setValue(0);
    }
  }
  checkEmail(type:number=1) {
    if (Helps.isValidEmail(this.form1.get('email')?.value)) {
      console.log("Valido:", this.form1.get('email')?.value);
        this.notSendVisEmail = false;
        this.notSendProvEmail = false;
    } else {
      console.log("No valido:", this.form1.get('email')?.value);
        this.notSendVisSms = true;
        this.form1.get('send_not_vis_email')?.setValue(0);
        this.notSendProvSms = true;
        this.form1.get('send_not_prov_email')?.setValue(0);
    }
  }
  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
